%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: f1565e2ac6d6cbe4bb0b302c1b554d10, type: 3}
  m_Name: CorporealProtection
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 110620, guid: dd18fef4bb6bc05418e566f124f04d44, type: 3}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 0}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 27
  castDelay: 180
  animationSpeed: 1.8
  animationDuration: 0.8
  skipCooldownOnChannel: 0
  spellName: Corporeal Protection
  description: Remove all <b>Stuns</b> and <b>Incapacitates</b> from the target.
    In addition, the target cannot be stunned and takes 100% reduced physical damage,
    but deals 100% reduced physical damage and 65% reduced magic damage for 8 seconds.
    The target is considered Honored for 28 seconds after use. Cannot be used while
    the target is Honored.
  icon: {fileID: 2800000, guid: 4d41bfb472e7f834e9c5517cf9ac0f22, type: 3}
  usableBy: 
  cooldown: 60
  castTime: 0
  isCastInterruptible: 1
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 0
  spellType: {fileID: 11400000, guid: 027489edcf0967b4c9cd9e38e44be6cf, type: 2}
